import {IDynamicDataConfig, IDynamicTreeContext, IProcessFlowMetadataSection, IDynamicField} from "~/interfaces/dynamicFieldsInterfaces";
import DynamicFieldsHandler from "~/models/dynamicFields/handlers/dynamicFieldsHandler";
import {
  DeterministicDynamicComponentType,
  IDeterministicDynamicFieldsHandler, IDynamicFieldsDestinationOptions,
  IProcessFlowMetadataOptions
} from "~/interfaces/dynamicFieldsElementOptionsInterfaces";
import {DynamicReferenceType} from "~/enums/dynamicReferenceType";
import {IProcessFlow} from "~/interfaces/processFlowInterfaces";
import {ReferencePathNode} from "~/models/referencePaths/referencePathNode";
import {ReferenceNodeType} from "~/enums/referenceNodeType";
import ProcessFlowDynamicFieldHandlerSelectMixin from "~/models/dynamicFields/handlers/mixins/processFlowDynamicFieldHandlerSelectMixin";
import {assignDynamicFieldsDestinationOptions} from "~/models/dynamicFields/helpers";
import {ModelType, ModelTypeIcon} from "~/enums/modelType";

type ItemTypes = IDynamicField

export default class ProcessFlowMetadataHandler extends DynamicFieldsHandler implements IDeterministicDynamicFieldsHandler<ItemTypes>, IDynamicFieldsDestinationOptions {
  COMPONENTS: Array<DeterministicDynamicComponentType> = ['process-flow-metadata']
  header: string = 'Process Flow Metadata';
  processFlow: IProcessFlow;
  destinationIsCollection: null;


  constructor(options: IProcessFlowMetadataOptions) {
    super(options);
    this.processFlow = options.processFlow;
    assignDynamicFieldsDestinationOptions(this, options);
  }

  metadataFields: Array<IDynamicField> = [
    {
      id: String(ReferenceNodeType.ProcessFlowInitiatorFirstName),
      label: metadataFieldLabels[ReferenceNodeType.ProcessFlowInitiatorFirstName],
    },
    {
      id: String(ReferenceNodeType.ProcessFlowInitiatorLastName),
      label: metadataFieldLabels[ReferenceNodeType.ProcessFlowInitiatorLastName],
    },
    {
      id: String(ReferenceNodeType.ProcessFlowInitiatorEmail),
      label: metadataFieldLabels[ReferenceNodeType.ProcessFlowInitiatorEmail],
    },
    {
      id: String(ReferenceNodeType.ProcessFlowTriggerTime),
      label: metadataFieldLabels[ReferenceNodeType.ProcessFlowTriggerTime],
    },
    {
      id: String(ReferenceNodeType.ProcessFlowTitle),
      label: metadataFieldLabels[ReferenceNodeType.ProcessFlowTitle],
    },
  ];

  metadataSection(q: string): IProcessFlowMetadataSection {
    return {
      metadata: this.metadataFields.filter(m => m.label.toLowerCase().match(q) !== null),
      isOpen: false,
    };
  }

  selectMetadata(item: ItemTypes): IDynamicDataConfig {
    const config: Omit<IDynamicDataConfig, 'id'> = {
      type: DynamicReferenceType.ProcessFlowMetadata,
      label: item.label,
      path: [new ReferencePathNode(null, {reference_type: Number(item.id), reference_id: item.id})],
    };
    return new ProcessFlowDynamicFieldHandlerSelectMixin(this).select(item, config);
  }

  isDisabled(item: ItemTypes, context: Partial<IDynamicTreeContext<ItemTypes>> = {}): boolean {
    return false;
  }

  isTopLevelCollection(item: ItemTypes, context: Partial<IDynamicTreeContext<ItemTypes>> = {}): boolean {
    return false;
  }
}

export const metadataFieldLabels = {
  [ReferenceNodeType.ProcessFlowInitiatorFirstName]: 'Initiator First Name',
  [ReferenceNodeType.ProcessFlowInitiatorLastName]: 'Initiator Last Name',
  [ReferenceNodeType.ProcessFlowInitiatorEmail]: 'Initiator Email',
  [ReferenceNodeType.ProcessFlowTriggerTime]: 'Time of Trigger',
  [ReferenceNodeType.ProcessFlowTitle]: 'Process Flow Title',
};